import * as React from "react";

import { Badge } from "Components/ui";
import { cn } from "utils/cn";

export interface TenantIdentityProps {
  name: string;
  /** The tenant's pm2 app; shown as a badge. */
  slug?: string | null;
  uri?: string | null;
  /** Greyed out, e.g. for a client whose TeleOpd isn't connected. */
  muted?: boolean;
  className?: string;
}

/**
 * How a client is shown in every list: its name, its pm2 app as a badge and its URL. Client names
 * repeat across instances ("General MetahOS Hospital"); the app and URL say which one it is.
 */
export const TenantIdentity: React.FC<TenantIdentityProps> = ({
  name,
  slug,
  uri,
  muted = false,
  className,
}) => (
  <div data-tenant-identity className={cn("min-w-0", muted && "grayscale", className)}>
    <div className="flex min-w-0 items-center gap-2">
      <p className={cn("truncate font-medium", muted && "text-muted-foreground")}>{name}</p>
      {slug && (
        <Badge className="shrink-0 font-mono" title="pm2 app">
          {slug}
        </Badge>
      )}
    </div>
    {uri && (
      <p className="truncate font-mono text-xs text-muted-foreground" title={uri}>
        {uri}
      </p>
    )}
  </div>
);

export default TenantIdentity;
